module.exports = __webpack_public_path__ + "static/banner-mobile-9c86709e2179a4927f36f28dea6d91c2.png";